import { render, staticRenderFns } from "./sortmodule.vue?vue&type=template&id=5b269fda"
import script from "./sortmodule.vue?vue&type=script&lang=js"
export * from "./sortmodule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports